import React, { useState, useContext } from 'react'; // Removed unused useEffect
import { AuthContext } from '../contexts/AuthContext';

const ZwalletTabs = ({
  activeTab,
  setActiveTab,
  balance,
  ethPrice,
  tokens,
  txHistory,
  formatHash,
  formatAddress,
  formatUSD,
  setShowAddToken,
  setShowSecurityModal,
  setShowSendModal,
  loading,
  refreshAccountData,
  account
}) => {
  const { isAuthenticated, ensName, address, logout } = useContext(AuthContext);
  
  const [copied, setCopied] = useState(false);

  const copyAddress = () => {
    if (address) {
      navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const shortenAddress = (addr) => {
    if (!addr) return '';
    return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
  };

  const tabs = [
    { id: 'overview', label: 'Overview', icon: '📊' },
    { id: 'tokens', label: 'Tokens', icon: '🪙' },
    { id: 'activity', label: 'Activity', icon: '📈' },
    { id: 'settings', label: 'Settings', icon: '⚙️' }
  ];

  return (
    <div style={{
      background: 'var(--black)',
      borderRadius: '12px',
      border: '1px solid var(--border)',
      overflow: 'hidden'
    }}>
      {/* Tabs Navigation */}
      <div style={{
        display: 'flex',
        borderBottom: '1px solid var(--border)',
        background: 'var(--card-bg)'
      }}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              flex: 1,
              padding: '15px',
              background: activeTab === tab.id ? 'var(--gold)' : 'transparent',
              color: activeTab === tab.id ? 'var(--black)' : 'var(--text-secondary)',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            <span>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tabs Content */}
      <div style={{ padding: '20px' }}>
        {/* Overview Tab */}
        {activeTab === 'overview' && (
          <div>
            <h3 style={{ color: 'var(--gold)', marginBottom: '20px' }}>Portfolio Overview</h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '15px',
              marginBottom: '20px'
            }}>
              <div style={{
                background: 'var(--card-bg)',
                padding: '15px',
                borderRadius: '8px',
                border: '1px solid var(--gold)'
              }}>
                <div style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>ETH Balance</div>
                <div style={{ color: 'var(--gold)', fontSize: '24px', fontWeight: 'bold' }}>
                  {parseFloat(balance || '0').toFixed(4)} ETH
                </div>
                <div style={{ color: 'var(--text-light)', fontSize: '14px' }}>
                  ${(parseFloat(balance || '0') * (ethPrice || 0)).toFixed(2)} USD
                </div>
              </div>
              
              <div style={{
                background: 'var(--card-bg)',
                padding: '15px',
                borderRadius: '8px',
                border: '1px solid var(--gold)'
              }}>
                <div style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>Token Count</div>
                <div style={{ color: 'var(--gold)', fontSize: '24px', fontWeight: 'bold' }}>
                  {tokens.length}
                </div>
                <div style={{ color: 'var(--text-light)', fontSize: '14px' }}>ERC-20 Tokens</div>
              </div>
              
              <div style={{
                background: 'var(--card-bg)',
                padding: '15px',
                borderRadius: '8px',
                border: '1px solid var(--gold)'
              }}>
                <div style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>Transaction History</div>
                <div style={{ color: 'var(--gold)', fontSize: '24px', fontWeight: 'bold' }}>
                  {txHistory.length}
                </div>
                <div style={{ color: 'var(--text-light)', fontSize: '14px' }}>Total Transactions</div>
              </div>
            </div>

            <div style={{
              background: 'var(--card-bg)',
              padding: '20px',
              borderRadius: '8px',
              border: '1px solid var(--gold)',
              marginBottom: '20px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h4 style={{ color: 'var(--gold)', margin: 0 }}>Wallet Address</h4>
                <button
                  onClick={copyAddress}
                  style={{
                    background: 'transparent',
                    color: 'var(--gold)',
                    border: '1px solid var(--gold)',
                    padding: '5px 10px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  {copied ? '✓ Copied' : '📋 Copy'}
                </button>
              </div>
              <div style={{
                background: 'var(--black)',
                padding: '10px',
                borderRadius: '6px',
                fontFamily: 'monospace',
                fontSize: '14px',
                color: 'var(--text-light)',
                wordBreak: 'break-all'
              }}>
                {address || 'Not connected'}
              </div>
              {ensName && (
                <div style={{
                  background: 'rgba(255, 215, 0, 0.1)',
                  padding: '10px',
                  borderRadius: '6px',
                  marginTop: '10px',
                  textAlign: 'center'
                }}>
                  <div style={{ color: 'var(--gold)', fontWeight: 'bold' }}>ENS Identity:</div>
                  <div style={{ color: 'var(--text-light)', fontFamily: 'monospace' }}>🌐 {ensName}</div>
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button
                onClick={refreshAccountData}
                disabled={loading}
                style={{
                  background: 'var(--gold)',
                  color: 'var(--black)',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontWeight: 'bold'
                }}
              >
                {loading ? 'Refreshing...' : '🔄 Refresh Data'}
              </button>
              <button
                onClick={() => setShowSendModal(true)}
                style={{
                  background: 'transparent',
                  color: 'var(--gold)',
                  border: '1px solid var(--gold)',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                💸 Send Funds
              </button>
            </div>
          </div>
        )}

        {/* Tokens Tab */}
        {activeTab === 'tokens' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ color: 'var(--gold)', margin: 0 }}>Token Balances</h3>
              <button
                onClick={() => setShowAddToken(true)}
                style={{
                  background: 'var(--gold)',
                  color: 'var(--black)',
                  border: 'none',
                  padding: '8px 15px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}
              >
                + Add Token
              </button>
            </div>
            
            {tokens.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-secondary)' }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>🪙</div>
                <p>No tokens found</p>
                <p style={{ fontSize: '14px' }}>Add tokens to track their balances</p>
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid var(--border)' }}>
                      <th style={{ padding: '10px', textAlign: 'left', color: 'var(--text-secondary)' }}>Token</th>
                      <th style={{ padding: '10px', textAlign: 'right', color: 'var(--text-secondary)' }}>Balance</th>
                      <th style={{ padding: '10px', textAlign: 'right', color: 'var(--text-secondary)' }}>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tokens.map((token, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '10px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                              width: '30px',
                              height: '30px',
                              borderRadius: '50%',
                              background: 'var(--gold)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'var(--black)',
                              fontWeight: 'bold'
                            }}>
                              {token.symbol ? token.symbol.charAt(0) : 'T'}
                            </div>
                            <div>
                              <div style={{ color: 'var(--gold)', fontWeight: 'bold' }}>{token.symbol || 'Unknown'}</div>
                              <div style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>{token.name || 'Token'}</div>
                            </div>
                          </div>
                        </td>
                        <td style={{ padding: '10px', textAlign: 'right', color: 'var(--text-light)' }}>
                          {parseFloat(token.balance || '0').toFixed(4)}
                        </td>
                        <td style={{ padding: '10px', textAlign: 'right', color: 'var(--text-light)' }}>
                          {formatUSD ? formatUSD(token.value || 0) : `$${(token.value || 0).toFixed(2)}`}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Activity Tab */}
        {activeTab === 'activity' && (
          <div>
            <h3 style={{ color: 'var(--gold)', marginBottom: '20px' }}>Transaction History</h3>
            
            {txHistory.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-secondary)' }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>📈</div>
                <p>No transactions yet</p>
                <p style={{ fontSize: '14px' }}>Transactions will appear here</p>
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid var(--border)' }}>
                      <th style={{ padding: '10px', textAlign: 'left', color: 'var(--text-secondary)' }}>Tx Hash</th>
                      <th style={{ padding: '10px', textAlign: 'left', color: 'var(--text-secondary)' }}>From/To</th>
                      <th style={{ padding: '10px', textAlign: 'right', color: 'var(--text-secondary)' }}>Value</th>
                      <th style={{ padding: '10px', textAlign: 'center', color: 'var(--text-secondary)' }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {txHistory.slice(0, 10).map((tx, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '10px' }}>
                          <a
                            href={`https://etherscan.io/tx/${tx.hash}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: 'var(--gold)',
                              textDecoration: 'none',
                              fontFamily: 'monospace',
                              fontSize: '12px'
                            }}
                          >
                            {formatHash ? formatHash(tx.hash) : `${tx.hash.substring(0, 10)}...`}
                          </a>
                        </td>
                        <td style={{ padding: '10px', color: 'var(--text-light)', fontSize: '12px' }}>
                          <div>From: {formatAddress ? formatAddress(tx.from) : shortenAddress(tx.from)}</div>
                          <div>To: {formatAddress ? formatAddress(tx.to) : shortenAddress(tx.to)}</div>
                        </td>
                        <td style={{ padding: '10px', textAlign: 'right', color: 'var(--text-light)' }}>
                          {parseFloat(tx.value || '0').toFixed(4)} ETH
                        </td>
                        <td style={{ padding: '10px', textAlign: 'center' }}>
                          <span style={{
                            background: tx.status === 'confirmed' ? 'rgba(0, 255, 136, 0.1)' : 'rgba(255, 215, 0, 0.1)',
                            color: tx.status === 'confirmed' ? '#00ff88' : 'var(--gold)',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}>
                            {tx.status === 'confirmed' ? '✓' : '⏳'} {tx.status || 'pending'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Settings Tab */}
        {activeTab === 'settings' && (
          <div>
            <h3 style={{ color: 'var(--gold)', marginBottom: '20px' }}>Wallet Settings</h3>
            
            <div style={{
              background: 'var(--card-bg)',
              padding: '20px',
              borderRadius: '8px',
              border: '1px solid var(--gold)',
              marginBottom: '20px'
            }}>
              <h4 style={{ color: 'var(--gold)', marginBottom: '15px' }}>Security & Privacy</h4>
              
              <div style={{ marginBottom: '15px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <span style={{ color: 'var(--text-light)' }}>Session Management</span>
                  <span style={{ color: 'var(--gold)', fontSize: '12px' }}>24h auto-logout</span>
                </div>
                <div style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>
                  Your session expires after 24 hours of inactivity
                </div>
              </div>
              
              <div style={{ marginBottom: '15px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <span style={{ color: 'var(--text-light)' }}>ENS Domain Verification</span>
                  <span style={{ color: isAuthenticated ? '#00ff88' : 'var(--gold)', fontSize: '12px' }}>
                    {isAuthenticated ? '✓ Verified' : 'Required'}
                  </span>
                </div>
                <div style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>
                  Access requires verified .zpost.eth domain ownership
                </div>
              </div>
              
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <span style={{ color: 'var(--text-light)' }}>Zwallet Exclusive</span>
                  <span style={{ color: 'var(--gold)', fontSize: '12px' }}>Active</span>
                </div>
                <div style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>
                  Only Zwallet with .zpost.eth domains can connect
                </div>
              </div>
            </div>

            <div style={{
              background: 'var(--card-bg)',
              padding: '20px',
              borderRadius: '8px',
              border: '1px solid var(--gold)',
              marginBottom: '20px'
            }}>
              <h4 style={{ color: 'var(--gold)', marginBottom: '15px' }}>Wallet Actions</h4>
              
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button
                  onClick={() => setShowSecurityModal(true)}
                  style={{
                    flex: 1,
                    background: 'transparent',
                    color: 'var(--gold)',
                    border: '1px solid var(--gold)',
                    padding: '10px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    minWidth: '150px'
                  }}
                >
                  🔐 Security Settings
                </button>
                
                <button
                  onClick={() => {
                    if (window.confirm('Are you sure you want to clear all cached data?')) {
                      localStorage.removeItem('zwallet_session');
                      sessionStorage.clear();
                      window.location.reload();
                    }
                  }}
                  style={{
                    flex: 1,
                    background: 'transparent',
                    color: 'var(--gold)',
                    border: '1px solid var(--gold)',
                    padding: '10px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    minWidth: '150px'
                  }}
                >
                  🗑️ Clear Cache
                </button>
              </div>
              
              <div style={{ marginTop: '15px' }}>
                <button
                  onClick={logout}
                  style={{
                    width: '100%',
                    background: 'transparent',
                    color: '#ff4444',
                    border: '1px solid #ff4444',
                    padding: '12px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: 'bold'
                  }}
                >
                  🚪 Sign Out
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ZwalletTabs;
